// store/modules/sesiunetaxe.js

import axios from 'axios';

const state = {
    currentSession: null,
    loading: false,
    error: null,
};

const getters = {
    getCurrentSession: (state) => state.currentSession,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
};

const actions = {
    async fetchCurrentSession({commit}) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);
        try {
            const response = await axios.get('/api/sesiunetaxe/current');
            commit('SET_CURRENT_SESSION', response.data.data);
        } catch (error) {
            commit('SET_ERROR', error.response?.data?.message || 'An error occurred');
        } finally {
            commit('SET_LOADING', false);
        }
    },
};

const mutations = {
    SET_CURRENT_SESSION(state, session) {
        state.currentSession = session;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
